import { createRouter, createWebHistory } from 'vue-router'
import GiftCards from '../views/GiftCardsStore.vue'
import NotFound from '../views/404.vue'

const routes = [
    {
        path: '/404', name: 'NotFound', component: NotFound
    },
    {
        path: '/:catchAll(.*)', redirect: '404'
    },
    {
        path: '/',
        name: 'home',
        component: GiftCards,
        meta: { requiresAuth: false, title: "Regala - Boston's Pizza", keepAlive: false }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});


export default router
